import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseStatistic, GameHockeyPosition, StatisticFilters } from '@mtgame/core';

@Component({
  selector: 'mtg-hockey-statistic-leaders',
  templateUrl: './hockey-statistic-leaders.component.html',
  styleUrls: ['../styles/shared.scss', './hockey-statistic-leaders.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HockeyStatisticLeadersComponent implements OnChanges {
  @Input()
  statistic: BaseStatistic[];
  @Input()
  seasonId: number;
  @Input()
  round: number;
  forwardStatistic: BaseStatistic[];
  defenderStatistic: BaseStatistic[];
  goaltenderStatistic: BaseStatistic[];

  forwardParams = [
    {
      id: 'points',
      title: 'Очки',
      sortParameters: [
        { name: 'totalGoals', sort: 'desc' },
        { name: 'gamesCount', sort: 'asc' }
      ]
    },
    {
      id: 'totalGoals',
      title: 'Шайбы',
      sortParameters: [
        { name: 'gamesCount', sort: 'asc' }
      ]
    },
    {
      id: 'assists',
      title: 'Передачи',
      sortParameters: [
        { name: 'gamesCount', sort: 'asc' }
      ]
    }
  ];
  goalkeeperParams = [
    // {
    //   id: 'safetyRate',
    //   back: 'safety_rate',
    //   title: 'ПШС'
    // },
    {
      id: 'totalSavesPercent',
      back: 'total_saves_percent',
      title: '% сейвов',
      sortParameters: [
        { name: 'gamesCount', sort: 'desc' }
      ]
    }
  ];
  forwardLeadersParam = this.forwardParams[0];
  defenderLeadersParam = this.forwardParams[0];
  goaltenderLeadersParam = this.goalkeeperParams[0];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.statistic) {
      this.forwardStatistic = this.statistic.filter(item => !item.newbie &&
        item.teamUser.user.hockeyProfile.position === GameHockeyPosition.forward);
      this.defenderStatistic = this.statistic.filter(item => !item.newbie &&
        item.teamUser.user.hockeyProfile.position === GameHockeyPosition.defensemen);
      this.goaltenderStatistic = this.statistic.filter(item => !item.newbie &&
        item.teamUser.user.id !== 6702 &&
        item.teamUser.user.hockeyProfile.position === GameHockeyPosition.goaltender);
    }
  }
}
